import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const JoiningConfirmation = (props) => {
    return (
        <Box textAlign='center'>
            <Typography
                color='initial'
                sx={{ mx: 2, my: 4, lineHeight: '2rem', fontSize: '1.375rem' }}>
                Please let us know that you will be joining on given date by confirming the joining
                below.
            </Typography>
            <Button variant='contained' color='primary' onClick={props.onSubmit}>
                Confirm Joining
            </Button>
        </Box>
    );
};

export default JoiningConfirmation;
